import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

const popup = document.getElementById('mg-cart-popup');
if (popup && !popup.dataset.ready) {
  popup.dataset.ready = 'true';
  const root = popup.dataset.root.replace(/\/?$/, '/');
  const content = popup.querySelector('[data-popup-content]');
  const status = popup.querySelector('[data-popup-status]');
  let generation = 0;
  let pending = false;
  let restoreFocus;
  let controller;
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || popup.dataset.error);
    return data;
  };
  const updateCount = count => { popup.querySelector('[data-popup-count]').textContent = `(${count})`; };
  const close = () => popup.close();
  popup.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', close));
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  popup.addEventListener('close', () => {
    generation++;
    controller?.abort();
    if (restoreFocus?.isConnected) restoreFocus.focus({ preventScroll: true });
  });
  document.addEventListener('mg:cart-added', event => {
    const { cart, sections, items } = event.detail || {};
    if (!cart || !Array.isArray(items)) return;
    event.target.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: items.map(item => ({ merchandiseId: String(item.id), quantity: item.quantity })),
      promise: Promise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections, items: cart.items, didError: false }
      })
    }));
  });
  document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
    if (event.action !== 'add' || event.detail?.mgPopup || !event.promise) return;
    const current = ++generation;
    const sourceModal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;
    const trigger = document.activeElement;
    try {
      const result = await event.promise;
      if (current !== generation || result?.detail?.didError || result?.userErrors?.length || !result?.cart) return;
      if (sourceModal?.open && sourceModal !== popup) {
        await new Promise(resolve => sourceModal.addEventListener('close', resolve, { once: true }));
      }
      if (current !== generation) return;
      document.querySelector('theme-drawer#cart-drawer')?.close?.();
      restoreFocus = trigger;
      status.textContent = '';
      content.textContent = popup.dataset.loading;
      content.setAttribute('aria-busy', 'true');
      updateCount(result.cart.totalQuantity);
      if (!popup.open) popup.showModal();
      controller?.abort();
      controller = new AbortController();
      const url = new URL(root, location.origin);
      url.searchParams.set('section_id', 'mg-cart-popup-offers');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('offers');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const offers = html.querySelector('[data-popup-offers]');
      if (!offers) throw new Error('offers');
      if (current !== generation) return;
      content.replaceChildren(...offers.childNodes);
      content.setAttribute('aria-busy', 'false');
      updateCount(offers.dataset.count);
    } catch (error) {
      if (current !== generation || error.name === 'AbortError' || !popup.open) return;
      content.textContent = popup.dataset.loadError;
      content.setAttribute('aria-busy', 'false');
    }
  });
  popup.addEventListener('click', async event => {
    const button = event.target.closest('[data-popup-add]');
    if (!button || pending || button.disabled) return;
    pending = true;
    const buttons = [...popup.querySelectorAll('[data-popup-add]')];
    buttons.forEach(control => { control.disabled = true; });
    const label = button.textContent;
    button.textContent = popup.dataset.busy;
    status.textContent = '';
    let added = false;
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    popup.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'dialog',
      lines: [{ merchandiseId: button.dataset.popupAdd, quantity: 1 }],
      detail: { mgPopup: true }, promise: deferred.promise
    }));
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0, 5);
      const response = await request(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.popupAdd, quantity: 1 }], sections, sections_url: location.pathname })
      });
      added = true;
      button.dataset.added = 'true';
      button.textContent = popup.dataset.added;
      status.textContent = popup.dataset.added;
      const cart = await request(root + 'cart.js');
      updateCount(cart.item_count);
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: response.sections, items: cart.items, mgPopup: true } });
    } catch (error) {
      deferred.reject(error);
      status.textContent = added ? popup.dataset.loadError : popup.dataset.error;
      if (!added) button.textContent = label;
    } finally {
      buttons.forEach(control => { control.disabled = control.hasAttribute('data-added'); });
      pending = false;
    }
  });
}
